import { AttivitaReale } from './didattica/attivita-reale';
import { Docente } from './didattica/docente';
import { FreqInfo } from './didattica/frequinfo';
import { Studente } from './didattica/studente';

export interface Recupero {

    id: any;

    idStudente: any;

    istanteRichiesta: Date;

    istanteValutazione?: Date;

    stato: StatoRecupero;

    idArFrequenza: any;

    idDocenteFrequenza: string;

    annoAccademicoFrequenza: string;

    idArConvalida?: any;

    idDocenteConvalida?: string;

    annoAccademicoConvalida?: string;

    idOperatore: any;

    autoreUltimaModifica: string;

    istanteUltimaModifica: Date;

    docenteConvalida: Docente;

    docenteFrequenza: Docente;

    insegnamentoFrequenza: AttivitaReale ;

    insegnamentoConvalida: AttivitaReale;

    studente: Studente;

    freqInfo: FreqInfo;

}

export enum StatoRecupero {
    INVALUTAZIONE = <any>'INVALUTAZIONE',
    APPROVATO = <any>'APPROVATO',
    RESPINTO = <any>'RESPINTO'
  }
